import React from "react";
import {
  Carbs,
  Kcal,
  NitroTech,
  Times,
  Serving,
  RecipeIngredients,
} from "@utils/defaultImages";

export const getMealNutrients = (selectedMeal, tab, t) => {
  if (!selectedMeal || !tab) return [];

  return [
    {
      label: t("dietPlanDashboard.mealListing.mealNutrientsData.Protein"),
      key: "Protein",
      icon: <NitroTech className="min-w-[30px] min-h-[30px]" />,
      unit: "g",
      tabColor: "rgb(215 223 255)",
      value:
        tab.category === "meals"
          ? selectedMeal?.nutrition?.[tab.type]?.Protein
          : selectedMeal?.snacks?.[`${tab.type}_snacks`]?.Proteins,
    },
    {
      label: t("dietPlanDashboard.mealListing.mealNutrientsData.Calorie"),
      key: "calories",
      icon: <Kcal className="min-w-[30px] min-h-[30px]" />,
      unit: "kCal",
      tabColor: "rgb(245 224 210)",
      value:
        tab.category === "meals"
          ? selectedMeal?.calories?.[tab.type]
          : selectedMeal?.snacks?.[`${tab.type}_snacks`]?.Calories,
    },
    {
      label: t("dietPlanDashboard.mealListing.mealNutrientsData.Carbs"),
      key: "Carbohydrates",
      icon: <Carbs className="min-w-[30px] min-h-[30px]" />,
      unit: "g",
      tabColor: "rgb(208 241 255)",
      value:
        tab.category === "meals"
          ? selectedMeal?.nutrition?.[tab.type]?.Carbohydrates
          : selectedMeal?.snacks?.[`${tab.type}_snacks`]?.Carbohydrates,
    },
  ];
};

export const getRecipeDetailsData = ({
  meal,
  mealType,
  carbValue,
  proteinValue,
  t,
}) => {
  if (!meal) return [];

  return [
    {
      label: t("recipeDetails.prepTime"),
      icon: <Times className="w-[40px] h-[40px]" />,
      tabColor: "#F0F6FF",
      value: meal?.PreparationTime?.split("(")[0]?.trim() ?? "-",
    },
    {
      label: t("recipeDetails.serving"),
      icon: <Serving className="w-[40px] h-[40px]" />,
      tabColor: "#F0F8FF",
      value: meal?.serving?.[mealType?.toLowerCase()] ?? 1,
    },
    {
      label: t("recipeDetails.carb"),
      icon: <Carbs className="w-[40px] h-[40px]" />,
      tabColor: "#F0F8FF",
      value: carbValue ?? "-",
    },
    {
      label: t("recipeDetails.calories"),
      icon: <Kcal className="w-[40px] h-[40px]" />,
      tabColor: "#F1FFF0",
      value: meal?.Calories ?? "-",
    },
    {
      label: t("recipeDetails.protiens"),
      icon: <NitroTech className="w-[40px] h-[40px]" />,
      tabColor: "#FFF8F0",
      value: proteinValue ?? "-",
    },
    {
      label: t("recipeDetails.ingredients"),
      icon: <RecipeIngredients className="w-[40px] h-[40px]" />,
      tabColor: "#FFF8F0",
      value: meal?.Ingredients?.length ?? 0,
    },
  ];
};
